import React from "react";

// react router
import { Link } from "react-router-dom";

// styles
import {
    SubscribeContainer,
    Container,
    LeftSession,
    Header,
    HeaderSpan,
    Text,
    RightSession,
    RightSessionText,
    SearchBox,
    Span,
    Input,
} from "../../styles/Subscribe";
import MailChimpComp from "./MailChimpComp";

function Subscribe(props) {
    return (
        <SubscribeContainer>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 d-flex flex-wrap">
                        <LeftSession className="col-12 col-md-6">
                            <Header>
                                <HeaderSpan className="me-2"> Find out first.</HeaderSpan>
                                <span>Get our emails for info on new items, sales and more.</span>
                            </Header>
                            <Text>
                                To learn more about how we use your information, read
                                our{" "}
                                <Link to="/content/privacy-policy">Privacy Policy</Link>
                                .
                            </Text>
                        </LeftSession>

                        <RightSession className="col-12 col-md-6">
                            <RightSessionText>
                                Make sure that you'r always the first who receives our
                                latest news and exclusive promotions. we never send
                                spam.
                            </RightSessionText>
                            <SearchBox>
                                <MailChimpComp />
                                {/* <Input />
                        <Span
                            style={{ borderRadius: "0px" }}
                            className="input-group-text"
                        >
                            Subscribe
                        </Span> */}
                            </SearchBox>
                        </RightSession>
                    </div>
                </div>
            </div>
        </SubscribeContainer>
    );
}

export default Subscribe;
